export default __webpack_public_path__ + "static/media/login-page.a6877f3e.jpg";